/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Faq_8_AInputs */

const en_vc_faq_8_a = /** @type {(inputs: Vc_Faq_8_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The interface is available in 21 languages, including Simplified and Traditional Chinese, Japanese and Korean. In the current web version, Chinese and Korean menus are missing some characters because of a known upstream font bug, so VectorCraft online starts in English for those browsers; the desktop apps are not affected.`)
};

const zh_vc_faq_8_a = /** @type {(inputs: Vc_Faq_8_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有。界面支持 21 种语言，包括简体中文、繁体中文、日语和韩语。不过目前的网页版因官方已知的字体问题，中文和韩文菜单会缺字，所以中文浏览器打开在线版时默认显示英文界面；桌面版不受影响。`)
};

/**
* | output |
* | --- |
* | "Yes. The interface is available in 21 languages, including Simplified and Traditional Chinese, Japanese and Korean. In the current web version, Chinese and K..." |
*
* @param {Vc_Faq_8_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_faq_8_a = /** @type {((inputs?: Vc_Faq_8_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Faq_8_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_faq_8_a(inputs)
	return zh_vc_faq_8_a(inputs)
});
export { vc_faq_8_a as "vc.faq.8.a" }